import {
  IImages,
  IProduct,
  IProductCategory,
  IProductColor,
  IProductCosts,
  IProductSize,
  IProductTicket,
  IRating,
} from 'entities/compilationContext/product';
import { ITravelAccommodation } from 'entities/compilationContext/travel-accommodation';
import { ITravelJourney } from 'entities/compilationContext/travel-journey';

export class SampleProduct implements IProduct {
  public constructor({
    id,
    name,
    images,
    description,
    currency,
    currencySymbol,
    costs,
    color,
    size,
    inStock,
    category,
    accommodation,
    journey,
    brand,
    metricId,
    metricValue,
    clientProductId,
    rating,
    ticket,
    isLowStock,
  }: IProduct) {
    this.id = id;
    this.name = name;
    this.images = images;
    this.description = description;
    this.currency = currency;
    this.currencySymbol = currencySymbol;
    this.costs = costs;
    this.color = color;
    this.size = size;
    this.inStock = inStock;
    this.category = category;
    this.accommodation = accommodation;
    this.journey = journey;
    this.brand = brand;
    this.metricId = metricId;
    this.metricValue = metricValue;
    this.clientProductId = clientProductId;
    this.rating = rating;
    this.ticket = ticket;
    this.isLowStock = isLowStock;
  }

  public id?: string;
  public name?: string;
  public images?: IImages;
  public description?: string;
  public currency?: string;
  public currencySymbol?: string;
  public costs?: IProductCosts;
  public color?: IProductColor;
  public size?: IProductSize;
  public inStock?: string;
  public category?: IProductCategory;
  public accommodation?: ITravelAccommodation;
  public journey?: ITravelJourney[];
  public brand?: string;
  public metricId?: string;
  public metricValue?: string;
  public clientProductId?: string;
  public rating?: IRating;
  public ticket?: IProductTicket;
  public isLowStock?: string;
}
